// extracted by mini-css-extract-plugin
module.exports = {"menu":"YearMenu_menu__PmehM","menumobile":"YearMenu_menumobile__eyUZe","menu-selected":"YearMenu_menu-selected__Vtc0s"};